import {
  AlertController,
  NavController,
  ViewController,
  Platform,
  NavParams,
} from "ionic-angular";
import { Http, Response } from "@angular/http";
import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import * as Mnemonic from "bitcore-mnemonic";
import { HomePage } from "../home/home";
import { IdolsListPage } from "../idols-list/idols-list";
import { PayEscrowPage } from "../pay-escrow/pay-escrow";

import { NodeService } from "../../services/node.service";
import { AppState } from "../../app/app.reducer";
import { AppUtilities } from "../../app/app.utilities";
import { TokensFetchAction, WalletFetchAction } from "../../app/app.actions";
import { User, Wallet } from "../../app/app.models";
import { WalletsendPage } from "../walletsend/walletsend";
import { WalletService } from "../../services/wallet.service";
import { ConfigService } from "../../services/config.service";
import { EscrowService } from "../../services/escrow.service";
import { TranslateService } from "@ngx-translate/core";
import { FirebaseService } from "../../services/firebase.service";
import { AuthService } from "../../services/auth.service";

@Component({
  selector: "page-wallet",
  templateUrl: "wallet.html",
})
export class WalletPage {
  public segment: string = "seeds";
  public user$: User;
  public wallet$: Wallet;
  public walletsendPage = WalletsendPage;
  address: string;
  mnemonic: string;
  public refresh;
  bitcoinValue: number;
  private dollarAmount: number;
  amount: number;
  isenabled: boolean = false;
  ios: boolean;
  watacoins: string;

  public constructor(
    public alertCtrl: AlertController,
    public navCtrl: NavController,
    public store: Store<AppState>,
    public utilities: AppUtilities,
    public walletService: WalletService,
    private http: Http,
    private configService: ConfigService,
    public viewCtrl: ViewController,
    public escrowService: EscrowService,
    public plt: Platform,
    private nodeService: NodeService,
    private translateService: TranslateService,
    private firebaseService: FirebaseService,
    public navParams: NavParams,
    private authService: AuthService
  ) {
    if (this.plt.is("ios")) {
      this.ios = true;
    } else {
      this.ios = false;
    }

    this.ios = false;

    if (this.navParams.get("segment")) {
      console.log("Segment wallet ", this.navParams.get("segment"));
      this.segment = this.navParams.get("segment");
    }

    this.user$ = this.authService.getUser();

    this.getWallet();
    this.address = this.walletService.getAddress();
    this.mnemonic = this.walletService.getMnemonic();
  }

  getBitcoinValue() {
    this.http
      .get("https://api.coinbase.com/v2/prices/spot?currency=USD")
      .subscribe((res: Response) => {
        if (res) {
          if (this.wallet$) {
            this.bitcoinValue = parseFloat(res.json().data.amount);
            this.dollarAmount = this.bitcoinValue * this.wallet$.ethers;
          }
        }
      });
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad WalletPage");
  }

  ionViewWillEnter() {}

  onCopyAddress() {
    var idioma = this.configService.getIdiom();
    if (idioma == "en")
      this.utilities.toast("Address copied to the clipboard.");
    if (idioma == "es")
      this.utilities.toast("Dirección copiada en el portapapeles.");
  }

  onCopySeeds() {
    var idioma = this.configService.getIdiom();
    if (idioma == "en") this.utilities.toast("Seed copied to the clipboard.");
    if (idioma == "es")
      this.utilities.toast("Semilla copiada en el portapapeles.");
  }

  showPrompt() {
    //traducciones
    var IMPORT_SEED = this.translateService.instant("IMPORT_SEED");
    var WRITE_SEED = this.translateService.instant("WRITE_SEED");
    var GUARDAR = this.translateService.instant("GUARDAR");
    var CANCELAR = this.translateService.instant("CANCELAR");

    let prompt;

    prompt = this.alertCtrl.create({
      //cssClass: "wallet-seeds-alert",
      subTitle: IMPORT_SEED,
      inputs: [
        {
          name: "seeds",
          placeholder: WRITE_SEED,
        },
      ],
      buttons: [
        {
          text: CANCELAR,
        },
        {
          text: GUARDAR,
          handler: (data) => {
            try {
              if (!Mnemonic.isValid(data.seeds)) throw new Error();
              this.walletService.updateSeeds(data.seeds).then(() => {
                this.firebaseService.updateUserAddresData(
                  this.user$.uid,
                  this.walletService.getAddress()
                );
                this.store.dispatch(new WalletFetchAction(this.user$));
                this.address = this.walletService.getAddress();
                this.mnemonic = this.walletService.getMnemonic();
                this.navCtrl.setRoot(IdolsListPage);
              });
            } catch (e) {
              this.utilities.alert("Introduce una semilla válida.");
            }
          },
        },
      ],
    });

    prompt.present();
  }

  doRefresh($event) {
    this.refresh = $event;
    // this.store.dispatch(new WalletFetchAction(this.user$));
    this.nodeService
      .getBalanceWatacoins()
      .then((wallet) => {
        var wata: any = wallet.watacoins;
        this.watacoins = this.formatNumberDeciaml(wata, 2);
        console.log("Watacoins market " + this.watacoins);
        $event.complete();
      })
      .catch((err) => {
        console.log("err");
      });
    //this.getBitcoinValue();
  }

  buyWatacoinsIOS() {
    var idioma = this.configService.getIdiom();
    if (idioma == "en")
      this.utilities.alert("Buy Watacoins soon on watafan.com");
    if (idioma == "es")
      this.utilities.alert("Compra Watacoins proximamente en watafan.com");
  }

  buyWatacoinsConfirm() {
    //translate
    var PURCHASE_WATACOINS_COMISION = this.translateService.instant(
      "PURCHASE_WATACOINS_COMISION"
    );
    var PURCHASE_WATACOINS_CONFIRM = this.translateService.instant(
      "PURCHASE_WATACOINS_CONFIRM"
    );
    var BUY_WATA = this.translateService.instant("BUY_WATA");
    var CANCELAR = this.translateService.instant("CANCELAR");
    var BUY_WATA_WARNING = this.translateService.instant("BUY_WATA_WARNING");

    var price1 = this.amount.toString().split(".")[1];
    var price2 = this.amount.toString().split(",")[1];

    if (price1 || price2) {
      this.messageAlertDeciamls();
    } else {
      console.log(" Buy watacoisn Confirm Amount: " + this.amount);
      if (this.amount >= 10 && this.amount <= 10000) {
        let alert;
        alert = this.alertCtrl.create({
          subTitle: PURCHASE_WATACOINS_COMISION,
          message: PURCHASE_WATACOINS_CONFIRM,
          buttons: [
            {
              text: CANCELAR,
              role: "cancel",
              handler: () => {
                console.log("Cancelar");
              },
            },
            {
              text: BUY_WATA,
              handler: () => {
                console.log("Buy clicked");
                this.buyWatacoins();
              },
            },
          ],
        });

        alert.present();
      } else {
        this.utilities.alert(BUY_WATA_WARNING);
      }
    }
  }

  buyWata() {
    var subtitle = this.translateService.instant("PURCHASE_WATA_TITLE");
    var CANCELAR = this.translateService.instant("CANCELAR");
    var BUY_WATA = this.translateService.instant("BUY_WATA");
    let prompt;
    prompt = this.alertCtrl.create({
      //cssClass: "wallet-seeds-alert",
      subTitle: subtitle,
      inputs: [
        {
          name: "euros",
          placeholder: "",
          type: "text",
        },
      ],
      buttons: [
        {
          text: CANCELAR,
        },
        {
          text: BUY_WATA,
          handler: (data) => {
            try {
              console.log("data to buy ", data);
              this.amount = parseInt(data.euros);
              console.log("watacoins to buy ", this.amount);
              this.buyWatacoinsConfirm();
            } catch (e) {}
          },
        },
      ],
    });
    prompt.present();
  }

  async buyWatacoins() {
    this.utilities.loading();

    try {
      var transaction = await this.escrowService.postExpress(
        this.amount.toString()
      );
      this.utilities.loadingDismiss();
      this.navCtrl.push(PayEscrowPage, { transaction: transaction });
    } catch (err) {
      console.log("error" + err);
      this.utilities.loadingDismiss();
    }
  }

  validar($event) {
    let val = parseInt($event.target.value);
    if (val > 0 && val <= 10000) {
      this.isenabled = true;
    } else {
      this.isenabled = false;
    }
  }
  messageAlertDeciamls() {
    var idioma = this.configService.getIdiom();
    if (idioma == "en")
      this.utilities.alert("The value of watacoins must be a integer number.");
    if (idioma == "es")
      this.utilities.alert("El valor de watacoins debe ser un número entero.");
  }

  formatNumberDeciaml(value: number, decimal: number): string {
    var formatValue;
    var idiom = this.configService.getIdiom();
    if (idiom == "es")
      formatValue = new Intl.NumberFormat("es-ES", {
        maximumFractionDigits: decimal,
      }).format(value);

    if (idiom == "en")
      formatValue = new Intl.NumberFormat("en-US", {
        maximumFractionDigits: decimal,
      }).format(value);
    console.log("format value " + formatValue);
    return formatValue;
  }

  getWallet() {
    this.utilities.loading();
    this.nodeService
      .getBalanceWatacoins()
      .then((wallet) => {
        var wata: any = wallet.watacoins;
        this.watacoins = this.formatNumberDeciaml(wata, 2);
        console.log("Watacoins market " + this.watacoins);
        this.utilities.loadingDismiss();
      })
      .catch((err) => {
        this.utilities.loadingDismiss();
        console.log("err");
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/wallet/wallet.ts